class MainCollection extends HTMLElement {
  static selectors = {
    view: '[data-view]',
    row: '[data-collection-row]'
  };
  static classes = {
    row: 'row-cols-xl-',
    active: 'opacity-25'
  }
  views; row; view;
  
  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.views = this.querySelectorAll(MainCollection.selectors.view);
    this.row = this.querySelector(MainCollection.selectors.row);
    this.view = this.dataset.defaultView;

    this.views.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.changeView(btn.dataset.view);
      });
    });
  }

  changeView = (view) => {
    if(this.row != null){
      this.row.classList.remove(MainCollection.classes.row+this.view);
      this.row.classList.add(MainCollection.classes.row+view);
      this.view = view;

      this.views.forEach((btn) => {
        if(btn.dataset.view == this.view){
          btn.classList.add(MainCollection.classes.active);
        }
        else {
          btn.classList.remove(MainCollection.classes.active);
        }
      });
    }
  }

}
if (!window.customElements.get("main-collection")) {
  window.customElements.define("main-collection", MainCollection);
}